module.exports = __webpack_public_path__ + "img/DSC_2737-xl.ee962431.png";